<template>
  <v-container fill-height fluid grid-list-xl>
    <v-dialog v-model="showDialog" :width="$vuetify.breakpoint.smAndDown ? '95%' : '70%'" style="min-height:90vh!important;" persistent>
      <v-card class="pa-2" height="100%">
        <!-- Título -->
        <v-toolbar color="light-blue" class="ma-2"
          style="color: white;display:flex;flex-direction:column;padding-top:5px;padding-bottom:5px;">
          <div style="min-width:100%!important;display:flex;justify-content:space-between;">
            <span class="toolbar-title"> 
              Histórico do Pagamento 
            </span> 
            </div>
        </v-toolbar>
        <br>
        <!-- Dados -->
        <v-data-table
          v-if="!$vuetify.breakpoint.smAndDown"
          :headers="headers"
          :items="items"
          :footer-props="footerProps"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items"> 
            {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
          </template>
          <template v-slot:[`item.datacriacao`]="{ item }">
            {{item.datacriacao | formatarDataYYHora}}
          </template>
          <template v-slot:[`item.valorpago`]="{ item }">
            <div class="item-value">{{item.valorpago | formatarMoeda}}</div>
          </template>
        </v-data-table>

        <div v-else>
          <v-card v-for="(item, index) in items" :key="index" class="mb-3" outlined>
            <v-card-title class="pb-1 d-flex justify-space-between">
              <span style="font-size: 1rem; font-weight: bold;">{{ item.nomehospede }} {{ item.sobrenomehospede }}</span>
              <span style="font-size: 0.9rem; color: gray;">Reserva: {{ item.numeroreserva }}</span>
            </v-card-title>
            <v-card-text>
              <v-row no-gutters class="mb-1">
                <v-col cols="6"><strong>Data:</strong> {{ item.datacriacao | formatarDataYYHora }}</v-col>
                <v-col cols="6"><strong>Status:</strong> {{ item.nome }}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div style="font-size: 1.2rem; font-weight: bold; color: #1976D2;">
                    {{ item.valorpago | formatarMoeda }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div v-if="items.length === 0" class="text-center py-4" style="color: gray;">
              Nenhum histórico encontrado.
          </div>
        </div>
        <v-card-actions>
            <v-spacer />
            <v-btn
              align-center
              justify-center
              color="primary"
              @click="$emit('closeitems')"
              >Fechar
            </v-btn>            
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  props: ['show','items'],
  data: () => ({
    footerProps: {
      'items-per-page-options': [6,12,24,{ text: "Todos", value: -1 }],
      'items-per-page-text': 'Linhas por página',
    },
    search: "",
    headers: [
      { text: "Nome", value: "nomehospede" },
      { text: "Sobrenome", value: "sobrenomehospede" },
      { text: "Reserva", value: "numeroreserva" },
      { text: "Data", value: "datacriacao" },
      { text: "Valor Pago", value: "valorpago", align: 'end' },
      { text: "Status", value: "nome" }
    ],
    showDialog: false
  }),
  computed: {
  },
  watch: {
    show(val) {
      this.showDialog = val
    }
  },
  created() {
    
  },
  methods: {
  },
};
</script>
<style scoped>
.item-value{
  font-size: 0.8rem!important;
}
</style>